import React, { FC } from 'react';
import styled from 'styled-components';
import { lightGray, white } from '../../utils/styles';
import { useAccordionContext } from '../Accordion/context';

const CardWrapper = styled.div<{ isActive: boolean }>`
  width: 100%;
  border-radius: 5px;
  transition: box-shadow 0.3s, transform 0.3s;
  box-shadow: 0 2px 2px -1px ${lightGray};
  background-color: ${white};
  margin-bottom: 24px;
  ${({ isActive }) => {
    if (!isActive) {
      return `&:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 4px -2px ${lightGray};
    }`;
    }
  }}
`;

export const CardAccordion: FC<{ index: number }> = ({ children, index }) => {
  const { isActiveSection } = useAccordionContext();
  return <CardWrapper isActive={isActiveSection(index)}>{children}</CardWrapper>;
};
